export class Localization {
  lc: string;
}
